import { Redirect } from 'expo-router';
import { useMemo } from 'react';

import { useMenuListQuery } from '@fhs/menu/src/queries/use-menu-list-query';
import { useLocale } from '@fhs-legacy/frontend/src/state/intl';
import { REGIONS } from '@fhs-legacy/frontend/src/state/intl/types';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

import { DEFAULT_RESTAURANT_ID, Region, ServiceMode } from '../queries/constants';

type SimplyMenuRedirectProps = {
  legacySlug: string;
};

export function SimplyMenuRedirect(props: SimplyMenuRedirectProps) {
  const { legacySlug } = props;
  const { store } = useStoreContext();
  const { region } = useLocale();
  const { isDelivery } = useServiceModeContext();
  const restaurantId = store.number || DEFAULT_RESTAURANT_ID;
  const serviceMode = isDelivery ? ServiceMode.DELIVERY : ServiceMode.PICKUP;
  const regionString = region === REGIONS.US ? Region.US : Region.CA;

  const { data, isLoading } = useMenuListQuery({
    restaurantId,
    serviceMode,
    region: regionString,
  });

  const urlMap = useMemo((): Map<string, string> => {
    if (!data) {
      return new Map();
    }
    const sectionItems = data.sections.flatMap(section => section.items);
    return new Map(sectionItems.map(item => [item._legacySlug, item.url]));
  }, [data]);

  if (isLoading || !data) {
    return null;
  }
  const redirectUrl = urlMap.get(legacySlug);

  if (redirectUrl) {
    return <Redirect href={redirectUrl} />;
  }

  return <Redirect href={routes.menu} />;
}
